module.exports = __webpack_public_path__ + "img/writingSeminar_041022_J.35c77909.jpg";